import React from "react"
import PropTypes from "prop-types"

import { Box } from "@material-ui/core"
import { createStyles, makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => {
  return createStyles({
    svg: {
      height: "100%",
      fill: props => props.color || theme.palette.grey[900],
    },
  })
})

const Logo = props => {
  const classes = useStyles(props)
  return (
    <svg height="25px" className={classes.svg} viewBox="0 0 1147 361.84">
      <path d="M470.4 46.9l.66 177.29L291.6 46.9v270h39.25l-.65-173.84L509.32 316.9v-270zM1058.33 179.66l85-132.49h-49.73l-57.87 97.37-63.51-97.37h-51.85l84.66 129.98-88.23 138.28h50.8l60.75-102.08 66.41 102.08H1147zM75.75 180.28L204.22 47.17h-52.99L39.45 162.53V47.26H0v269.59h39.45v-118.8l110.92 117.93.83.87h53.02zM824.34 0L786.7 60.3c-17.65-8.54-36.6-12.93-56.53-12.93-24.01 0-46.47 6.15-66.78 18.29-20.26 12.11-36.61 28.58-48.6 48.96-12.01 20.41-18.1 42.81-18.1 66.58 0 24.49 6.03 47.18 17.92 67.47 8.36 14.28 18.99 26.51 31.64 36.63l-40.7 65.21 18.35 11.57L842.7 11.54 824.34 0zm-173.9 228.49c-8.17-14.31-12.32-30.09-12.32-46.93 0-17.07 4.1-33.1 12.17-47.67 8.07-14.54 19.29-26.23 33.38-34.75 14.06-8.51 29.71-12.82 46.51-12.82 12.65 0 24.64 2.42 35.8 7.19l-97.97 156.96c-6.84-6.38-12.8-13.65-17.57-21.98zM845.74 114.61c-6.54-11-14.49-20.71-23.51-29.33l-21.59 34.6c3.55 4.23 6.84 8.71 9.64 13.68 8.18 14.56 12.33 30.59 12.33 47.65s-4.1 33.05-12.16 47.48c-8.07 14.43-19.24 25.94-33.19 34.23-13.95 8.28-29.54 12.48-46.35 12.48-8.71 0-17.09-1.24-25.14-3.51l-21.61 34.62c14.57 5.34 29.94 8.18 46.04 8.18 23.75 0 46.21-6.03 66.74-17.91 20.51-11.87 36.98-28.23 49-48.64 12-20.41 18.09-42.93 18.09-66.94-.01-23.76-6.16-46.16-18.29-66.59z" />
    </svg>
  )
}

Logo.propTypes = {
  children: PropTypes.string,
  color: PropTypes.string,
}

export default Logo
